import {dashboardUpdateInterval, updateDashboard} from "./dashboard-updater";
import {setAsyncTimeoutWithTurbolinks} from "./utils";

export function recursiveMainDashboardUpdate(period, charts) {
  const interval = dashboardUpdateInterval(period);
  setAsyncTimeoutWithTurbolinks(updateDashboard, [period, charts], interval);
}
